import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

export default function LudoLeaveConfirmDialog({
  open,
  isBotGame,
  stake,
  leaving,
  onCancel,
  onConfirm,
}) {
  if (!open) return null;

  return (
    <div
      className="ludo-leave-overlay"
      role="presentation"
      onClick={leaving ? undefined : onCancel}
    >
      <div
        className="ludo-leave-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="ludo-leave-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="ludo-leave-card__icon" aria-hidden>
          <WarningAmberRoundedIcon />
        </div>
        <h2 id="ludo-leave-title" className="ludo-leave-card__title">
          {isBotGame ? 'Leave practice game?' : 'Leave this game?'}
        </h2>
        <p className="ludo-leave-card__message">
          {isBotGame ? (
            'Your progress will be lost and the match will end.'
          ) : (
            <>
              If you leave now, you will <strong>forfeit</strong> and lose your{' '}
              <strong>₹{Number(stake || 0).toLocaleString('en-IN')}</strong> stake.
              Your opponent wins the pool.
            </>
          )}
        </p>
        {!isBotGame ? (
          <p className="ludo-leave-card__hint">This cannot be undone once you leave.</p>
        ) : null}
        <div className="ludo-leave-card__actions">
          <button
            type="button"
            className="ludo-leave-card__btn ludo-leave-card__btn--stay"
            onClick={onCancel}
            disabled={leaving}
          >
            Keep playing
          </button>
          <button
            type="button"
            className="ludo-leave-card__btn ludo-leave-card__btn--leave"
            onClick={onConfirm}
            disabled={leaving}
          >
            {leaving ? 'Leaving…' : 'Leave game'}
          </button>
        </div>
      </div>
    </div>
  );
}
